module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.ttf?11240b3672286420f295746b22127460]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.ttf
// module id = 1882
// module chunks = 32